import { isNull } from 'lodash-es'

import { convertFormValuesToReceiptInformation } from '@/features/update-receipt-information'

import { useSignUpGuestStore } from './guest-sign-up'
import { TSignUpHostConversionForm } from './host-conversion-form'
import { useSignUpHostStore } from './host-sign-up'

export const convertFormValuesToSignUpGuest = () => {
  const { terms, info, verification } = useSignUpGuestStore.getState()

  if (!terms || !info || !verification) {
    return null
  }

  const { marketingAgree } = terms
  const { email, password, name, profileImageUrl } = info
  const {
    phoneNumber,
    certNum,
    passportImageUrl,
    contactNumber,
    ocrToken,
    emailCertToken,
  } = verification

  return {
    marketingAgree,
    email,
    password,
    name,
    phoneNumber: phoneNumber || contactNumber,
    ...(profileImageUrl && { profileImageUrl }),
    ...(passportImageUrl && { passportImageUrl }),
    ...(certNum && { certNum }),
    ...(ocrToken && { ocrToken }),
    ...(emailCertToken && { emailCertToken }),
  }
}

export const convertFormValuesToSignUpHost = () => {
  const { terms, info, pay } = useSignUpHostStore.getState()

  if (!terms || !info || !pay) {
    return null
  }

  const { marketingAgree } = terms
  const {
    email,
    password,
    name,
    profileImageUrl,
    hostIntro,
    phoneNumber,
    certNum,
  } = info
  const {
    bankAccount,
    bankName,
    accountHolder,
    recommenderPhoneNumber,
    ...receiptInformationFormValues
  } = pay

  const {
    receiptRequested,
    taxReceiptType,
    corpId,
    corpName,
    corpCeo,
    invoiceeEmail,
    issuanceNumber,
  } = convertFormValuesToReceiptInformation(receiptInformationFormValues)

  return {
    marketingAgree,
    email,
    password,
    name,
    phoneNumber,
    ...(certNum && { certNum }),
    ...(profileImageUrl && { profileImageUrl }),
    ...(hostIntro && { hostIntro }),
    ...(bankAccount && { bankAccount }),
    ...(bankName && { bankName }),
    ...(accountHolder && { bankHolder: accountHolder }),
    ...(!isNull(receiptRequested) && { receiptRequested }),
    ...(taxReceiptType && { taxReceiptType }),
    ...(corpId && { corpId }),
    ...(corpName && { corpName }),
    ...(corpCeo && { corpCeo }),
    ...(invoiceeEmail && { invoiceeEmail }),
    ...(issuanceNumber && { issuanceNumber }),
    ...(recommenderPhoneNumber && { recommenderPhoneNumber }),
  }
}

export const convertFormValuesToSignUpHostConversion = ({
  hostIntro,
  accountHolder,
  bankName,
  bankAccount,
  recommenderPhoneNumber,
  ...receiptInformationFormValues
}: TSignUpHostConversionForm) => {
  const {
    receiptRequested,
    taxReceiptType,
    corpId,
    corpName,
    corpCeo,
    invoiceeEmail,
    issuanceNumber,
  } = convertFormValuesToReceiptInformation(receiptInformationFormValues)

  return {
    hostIntro,
    ...(bankAccount && { bankAccount }),
    ...(bankName && { bankName }),
    ...(accountHolder && { bankHolder: accountHolder }),
    ...(!isNull(receiptRequested) && { receiptRequested }),
    ...(taxReceiptType && { taxReceiptType }),
    ...(corpId && { corpId }),
    ...(corpName && { corpName }),
    ...(corpCeo && { corpCeo }),
    ...(invoiceeEmail && { invoiceeEmail }),
    ...(issuanceNumber && { issuanceNumber }),
    ...(recommenderPhoneNumber && { recommenderPhoneNumber }),
  }
}
